export const FLAG_GETTING_FUEL_PROFILES = 'FLAG_GETTING_FUEL_PROFILES';
export const GET_FUEL_PROFILES = 'GET_FUEL_PROFILES';
export const CLEAR_FUEL_PROFILES = 'CLEAR_FUEL_PROFILES';
export const FLAG_FUEL_PROFILE_ACTIVITY = 'FLAG_FUEL_PROFILE_ACTIVITY';
export const GET_FUEL_PROFILE = 'GET_FUEL_PROFILE';
export const CLEAR_FUEL_PROFILE = 'CLEAR_FUEL_PROFILE';
export const POST_FUEL_PROFILE = 'POST_FUEL_PROFILE';
export const PUT_FUEL_PROFILE = 'PUT_FUEL_PROFILE';
export const PATCH_FUEL_PROFILE = 'PATCH_FUEL_PROFILE';
